import { ImageOff } from 'lucide-react'
import { GalleryFieldInput } from '../../GalleryFieldInput'
import { ReadValuePlaceholder } from './ReadValuePlaceholder'
import { useFieldDensity } from '../FieldDensity'
import type { FieldDefinition } from '../../../types'

/**
 * Read-mode dla pola GALLERY. Zachowanie identyczne z oryginalnym FieldRenderer:
 * gdy contractId + documentTypeId są dostępne, renderuje {@code GalleryFieldInput}
 * disabled (kafelki BEZ akcji upload/delete, lub własny placeholder gdy lista pusta).
 * Bez {@code documentTypeId} -- spadamy do generic "—".
 *
 * W trybie compact (sidebar) placeholder "Brak zdjęć" jest mniejszy, a grid
 * thumbnaili kompaktowy (2 kolumny zamiast siatek 3-6).
 */
export function GalleryReadView({
  field, value, contractId,
}: { field: FieldDefinition; value: unknown; contractId?: number }) {
  const density = useFieldDensity()
  const ids = Array.isArray(value)
    ? value.map(v => Number(v)).filter(n => !Number.isNaN(n))
    : []

  if (ids.length === 0) {
    if (density === 'compact') {
      return (
        <div className="flex items-center gap-1.5 text-slate-400 py-0.5">
          <ImageOff size={13} />
          <span className="text-xs">Brak zdjęć</span>
        </div>
      )
    }
    // GalleryFieldInput w disabled+empty renderuje pusty grid (button "Dodaj" jest
    // ukryty, value.map() nic nie produkuje). Pokazujemy placeholder z ikonką żeby
    // wizualnie pasowało do gallery-grid (square tile), nie wyglądało jak text input.
    return (
      <div className="h-[72px] flex flex-col items-center justify-center gap-1 rounded-md border border-dashed border-slate-200 bg-slate-50/40 text-slate-400">
        <ImageOff size={18} />
        <span className="text-xs">Brak zdjęć</span>
      </div>
    )
  }
  if (contractId && field.documentTypeId) {
    return (
      <GalleryFieldInput
        contractId={contractId}
        documentTypeId={field.documentTypeId}
        value={ids}
        onChange={() => { /* read-only - no-op */ }}
        disabled
      />
    )
  }
  return <ReadValuePlaceholder display="—" />
}
